module.exports = __webpack_public_path__ + "img/icon2.56dafedb.png";